// src/lib/windgram/isolines.js
const EPS = 1e-9;
const HALF = 0.5;

const at = (grid, width, col, row) => { const v = grid[row * width + col]; return v != null ? v : 0; };
const bump = (e, a) => (Math.abs(e - a) < EPS ? a + EPS : e);          // Cn
const above = (e, a) => bump(e, a) > a;                                // ce
const frac = (e, a, n) => (e === a ? 0.5 : (n - e) / (a - e));         // he
const center = (p) => ({ x: p.x + HALF, y: p.y + HALF });             // bt

// Skysight Mn(): marching squares over a row-major grid → array of 2-point segments.
export function isolines(grid, width, height, threshold) {
  if (width < 2 || height < 2) return [];
  const out = [];
  for (let r = 0; r < height - 1; r++) {
    for (let c = 0; c < width - 1; c++) {
      const f = at(grid, width, c, r), u = at(grid, width, c + 1, r),
            w = at(grid, width, c + 1, r + 1), m = at(grid, width, c, r + 1);
      const zf = above(f, threshold), hu = above(u, threshold),
            pw = above(w, threshold), vm = above(m, threshold);
      const edges = {};
      if (zf !== hu) edges.top = { x: c + frac(f, u, threshold), y: r };
      if (hu !== pw) edges.right = { x: c + 1, y: r + frac(u, w, threshold) };
      if (vm !== pw) edges.bottom = { x: c + frac(m, w, threshold), y: r + 1 };
      if (zf !== vm) edges.left = { x: c, y: r + frac(f, m, threshold) };
      const pts = Object.values(edges);
      if (pts.length === 2) { out.push([center(pts[0]), center(pts[1])]); continue; }
      if (pts.length === 4) {
        if (zf && pw && !hu && !vm) {
          out.push([center(edges.top), center(edges.left)]);
          out.push([center(edges.right), center(edges.bottom)]);
        } else if (hu && vm && !zf && !pw) {
          out.push([center(edges.top), center(edges.right)]);
          out.push([center(edges.bottom), center(edges.left)]);
        }
      }
    }
  }
  return out;
}
